module.exports = __webpack_public_path__ + "static/media/esewa.67508249.png";